(function () {
  'use strict';

  var STATES = ['maintenance', 'countdown', 'final'];
  var WD_JP = ['日', '月', '火', '水', '木', '金', '土'];
  var FINAL_WIN_SEC = 10;
  var COUNTDOWN_WIN_MIN = 60;

  function cfg() { return window.PW_CONFIG || {}; }

  // Force state via URL: ?pw_state=open  or  #pw=open
  function forcedFromUrl() {
    try {
      var q = new URLSearchParams(window.location.search).get('pw_state');
      if (q && STATES.indexOf(q) !== -1) return q;
      var h = (window.location.hash || '').replace(/^#/, '');
      if (h.indexOf('pw=') === 0) {
        var v = h.slice(3);
        if (STATES.indexOf(v) !== -1) return v;
      }
    } catch (e) {}
    return null;
  }

  // Returns a Date whose UTC fields equal current JST.
  // n.getTime() is UTC epoch regardless of the browser's local TZ,
  // so we shift by +9h and read .getUTC*() to get JST values.
  function nowJst() {
    return new Date(Date.now() + 9 * 3600 * 1000);
  }

  // Parse "YYYY-MM-DD HH:MM" (JST) → Date whose UTC fields equal JST.
  function parseOpenDatetime(str) {
    if (!str) return null;
    var m = /^\s*(\d{4})[-\/](\d{1,2})[-\/](\d{1,2})[T\s]+(\d{1,2})[:：](\d{1,2})(?::(\d{1,2}))?/.exec(str);
    if (!m) return null;
    return new Date(Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0)));
  }

  // Fallback: next 11:00 JST from given JST-as-UTC date.
  function nextElevenAm(d) {
    var t = new Date(d.getTime());
    t.setUTCHours(11, 0, 0, 0);
    if (t.getTime() <= d.getTime()) {
      t.setUTCDate(t.getUTCDate() + 1);
    }
    return t;
  }

  function getTarget(d) {
    var t = parseOpenDatetime(cfg().open_datetime);
    return t || nextElevenAm(d);
  }

  function pickState(d, target) {
    var forced = forcedFromUrl();
    if (forced) return forced;

    var preview = cfg().preview_state;
    if (preview && preview !== 'auto' && STATES.indexOf(preview) !== -1) {
      return preview;
    }

    var diff = target.getTime() - d.getTime();
    var finalWin = FINAL_WIN_SEC * 1000;
    var countdownWin = COUNTDOWN_WIN_MIN * 60 * 1000;

    // After target reaches, stay on final state until admin disables password.
    if (diff <= finalWin) return 'final';
    if (diff <= countdownWin) return 'countdown';
    return 'maintenance';
  }

  function pad2(n) { return n < 10 ? '0' + n : '' + n; }

  function formatMMSS(ms) {
    if (ms < 0) ms = 0;
    // Use ceil so the boundary with final-countdown lines up:
    // diff = 11000ms → countdown shows "00:11"
    // diff = 10000ms → final shows "10"
    var total = Math.ceil(ms / 1000);
    var m = Math.floor(total / 60);
    var s = total % 60;
    return pad2(m) + ':' + pad2(s);
  }

  function formatReopenText(target) {
    var month = target.getUTCMonth() + 1;
    var day = target.getUTCDate();
    var dow = WD_JP[target.getUTCDay()];
    var hour = pad2(target.getUTCHours());
    var min = pad2(target.getUTCMinutes());
    return '次回は、' + month + '月' + day + '日（' + dow + '）' +
      '<br class="pw-band__sub-br">' +
      hour + ':' + min + 'から再開します。';
  }

  function applyState(name) {
    var wrapper = document.querySelector('.pw-wrapper');
    if (wrapper) wrapper.classList.remove('pw-state--loading');

    var states = document.querySelectorAll('.pw-state');
    for (var i = 0; i < states.length; i++) {
      var el = states[i];
      if (el.getAttribute('data-state') === name) {
        el.classList.add('pw-state--active');
      } else {
        el.classList.remove('pw-state--active');
      }
    }
  }

  function applyReopenText(target) {
    var override = (cfg().reopen_text_override || '').trim();
    var text = override || (cfg().open_datetime ? formatReopenText(target) : '');
    var nodes = document.querySelectorAll('[data-pw-reopen]');
    for (var i = 0; i < nodes.length; i++) {
      if (text) {
        nodes[i].innerHTML = text;
        nodes[i].style.display = '';
      } else {
        nodes[i].innerHTML = '';
        nodes[i].style.display = 'none';
      }
    }
  }

  function updateTimers(d, target) {
    var diff = target.getTime() - d.getTime();
    var mmss = document.querySelector('[data-pw-countdown]');
    if (mmss) mmss.textContent = formatMMSS(diff);

    var finalNum = document.querySelector('[data-pw-final-number]');
    if (finalNum) {
      var sLeft = Math.max(0, Math.ceil(diff / 1000));
      finalNum.textContent = sLeft > FINAL_WIN_SEC ? String(FINAL_WIN_SEC) : String(sLeft);
      if (sLeft <= 0) enableFinalRedirect();
    }
  }

  function enableFinalRedirect() {
    var section = document.querySelector('[data-state="final"]');
    if (!section || section.dataset.redirectArmed === '1') return;
    section.dataset.redirectArmed = '1';
    section.classList.add('pw-final--ended');
    section.addEventListener('click', function () {
      var url = section.getAttribute('data-pw-final-redirect') || '/';
      window.location.href = url;
    });
  }

  function setupFinalVideoEnd() {
    var video = document.querySelector('[data-pw-final-video]');
    if (!video || video.dataset.endedHooked === '1') return;
    video.dataset.endedHooked = '1';
    video.addEventListener('ended', enableFinalRedirect);
  }

  var _timer = null;
  function tick() {
    var d = nowJst();
    var target = getTarget(d);
    var state = pickState(d, target);
    applyState(state);
    applyReopenText(target);
    updateTimers(d, target);
    if (state === 'final') setupFinalVideoEnd();
  }

  function start() {
    tick();
    if (_timer) clearInterval(_timer);
    _timer = setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('.pw-wrapper')) {
      start();
    }
  });

  window.addEventListener('hashchange', tick);

  // Console helper for QA
  window.PW_FORCE = function (s) {
    if (STATES.indexOf(s) === -1 && s !== 'auto') {
      console.warn('PW_FORCE: invalid state', s, 'expected one of', STATES);
      return;
    }
    window.PW_CONFIG = window.PW_CONFIG || {};
    window.PW_CONFIG.preview_state = s;
    tick();
  };
})();
